<template>
  <ul class="flex my-2">
    <li class="mr-2" v-if="externalIds && externalIds.facebook_id">
      <a
        :href="`https://facebook.com/${externalIds.facebook_id}`"
        target="_blank"
        rel="noopener noreferrer"
        class="text-white font-semibold"
      >
        <button-icon :style="'bg-gray-700'" :color="'text-white'"
          ><i class="fab fa-facebook-f"></i></button-icon
      ></a>
    </li>
    <li class="mr-2" v-if="externalIds && externalIds.twitter_id">
      <a
        :href="`https://twitter.com/${externalIds.twitter_id}`"
        target="_blank"
        rel="noopener noreferrer"
        class="text-white font-semibold"
        ><button-icon :style="'bg-gray-700'" :color="'text-white'"
          ><i class="fab fa-twitter"></i></button-icon
      ></a>
    </li>
    <li class="mr-2" v-if="externalIds && externalIds.instagram_id">
      <a
        :href="`https://instagram.com/${externalIds.instagram_id}`"
        target="_blank"
        rel="noopener noreferrer"
        class="text-white font-semibold"
      >
        <button-icon :style="'bg-gray-700'" :color="'text-white'"
          ><i class="fab fa-instagram"></i
        ></button-icon>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "socials",
  props: {
    externalIds: Object
  }
};
</script>
